import { Box } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { EmtTypography, EmtModal, EmtButton } from 'emt-components-v2'
import { useUIStore } from '@/store/ui/uiStore'
import { useRouter } from 'next/router'
import { Routes } from '@/assets/configs'

// Store
import { useEMTDispatch } from '@/store'

import { AuthServiceHelper } from '@/modules/Auth'

const DisconnectionModal: React.FC = () => {
  const { t } = useTranslation('common')
  const dispatch = useEMTDispatch()
  const { disconnectionModalOpen, setDisconnectionModalClose } = useUIStore()
  const router = useRouter()

  return (
    <EmtModal
      open={disconnectionModalOpen || false}
      onClose={async () => {
        await AuthServiceHelper.dispatchLogoutAsync(dispatch)()
        setDisconnectionModalClose?.(false)
        router.replace(Routes.Connection.SignIn)
      }}
      sx={{ '& .inner-box': { width: '463px', maxWidth: '90vw' }, '& .children-box': { padding: '32px' } }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          textAlign: 'center',
        }}
      >
        <EmtTypography variant="h4" fontWeight={800}>
          {t('disconnectionModal.title')}
        </EmtTypography>
        <EmtTypography variant="body1">{t('disconnectionModal.subtitle')}</EmtTypography>
        <EmtTypography variant="body1">{t('disconnectionModal.description')}</EmtTypography>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            justifyContent: 'center',
          }}
        >
          <EmtButton
            fullWidth
            variant="contained"
            onClick={async () => {
              await AuthServiceHelper.dispatchLogoutAsync(dispatch)()
              setDisconnectionModalClose?.(false)
              router.replace(Routes.Connection.SignIn)
            }}
          >
            {t('disconnectionModal.button')}
          </EmtButton>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default DisconnectionModal
